import { i as isArray } from './instanceof-467ce6ea.js';
import { f as flatten } from './flatten-8cecedd9.js';
import { i as isEmptyObj } from './isEmptyObj-9e2fc2f5.js';
import { i as isObj } from './isObj-665859c3.js';

/**
 * 将对象转化为search字符串
 *
 * @param {Object} urlParams 参数对象
 * @return {string} 拼接过的 url string
 */
var stringifyQuery = function (urlParams) {
    if (urlParams === void 0) { urlParams = {}; }
    var result = '';
    var process = function (data) {
        Object.keys(data).forEach(function (key) {
            var _a;
            var value = data[key];
            if (value === null) {
                value = '';
            }
            else if (isObj(value) || isArray(value)) {
                if (isEmptyObj(value) || value.length === 0) {
                    value = '';
                }
                else {
                    process(flatten((_a = {}, _a[key] = value, _a)));
                    value = undefined;
                }
            }
            if (value !== undefined) {
                result += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
            }
        });
    };
    process(urlParams);
    return result.slice(1);
};

export { stringifyQuery as s };
//# sourceMappingURL=stringifyQuery-bfb464ad.js.map
